














import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';
import StartPageSlider from '../../parts/slider/StartPageSlider.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

export default {
  components: { AppPicture, StartPageSlider },
  props: {
    cfg: {
      type: Object as () => LayoutConfig['footer']['sections']['siteNavigationList'],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['logos'],
    },
  },
  methods: {
    click(id) {
      this.$router.push(`/organization/${id}`);
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/logo/Logos.vue